import "bootstrap";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

// Base stylesheet needed for every page
import './scss/app.scss';

// Lazy load page depended scripts and stylesheets method
const loadComponent = async name => {
    const {default: component} = await import(`./${name}.js`);

    return component();
}

// Import everything in directory method used for example for images
const importAll = (r) => r.keys().forEach(r);


$(document).ready(() => {
    // Include script foreach page example:
    require('./scripts/carousel.js');
    require('./scripts/header.js');
    require('./scripts/menu.js');
    require('./scripts/popover.js');
    require('./scripts/translate.js');
    require('./scripts/video.js');
    require('./scripts/wishlist.js');
    require('./scripts/horizontal.js');
    require('./scripts/links.js');
    require('./scripts/scrollbar.js');
    require('./scripts/arrowcontrols.js');
    require('./scripts/_microcart.js');
    require('./scripts/newsletter.js');
    require('./scripts/recaptcha.js');
});

if(document.querySelector('.js-product-page') !== null) {
    loadComponent('productdetails');
}

if(document.querySelector('.js-wishlist-overview') !== null) {
    loadComponent('wishlistoverview');
}

if(document.querySelector('.js-cart') !== null) {
    loadComponent('cart');
}

if(document.querySelector('.js-productlist') !== null) {
    loadComponent('productlist');
}

if(document.querySelector('.js-checkout') !== null) {
    loadComponent('checkout');
}

if(document.querySelector('.js-lazylist') !== null) {
    require('./scripts/lazylist.js');
    require('./scripts/pagination.js');
}

if(document.querySelector('.js-categorylist') !== null) {
    require('./scripts/categorylist.js');
}

// Importing all images
const images = require.context('./images', true,  /\.(png|jpe?g|gif)$/);
importAll(images);

